export const FORM_LABEL_STYLE = { fontSize: '12px', color: '#555', marginBottom: '3px', display: 'block' };
export const FORM_INPUT_STYLE = { padding: '8px', borderRadius: '4px', border: '1px solid #ccc', width: '100%', boxSizing: 'border-box' };
const ERROR_STYLE = { fontSize: '11px', color: '#e74c3c', marginTop: '3px' };

/**
 * FormField — label (with red asterisk when required) + the field itself + an
 * inline error line. Wraps whatever input/select/textarea you pass as children
 * so it drops into the existing inline-style create/edit forms without changing
 * their layout.
 *
 * Props:
 *   label       — field label text
 *   required    — shows a red asterisk after the label
 *   error       — error message string; renders below the field when present
 *   gridColumn  — optional CSS gridColumn override (e.g. 'span 2' for textareas)
 */
export default function FormField({ label, required, error, gridColumn, children }) {
  return (
    <div style={gridColumn ? { gridColumn } : undefined}>
      <label style={FORM_LABEL_STYLE}>
        {label}{required && <span style={{ color: '#e74c3c' }}> *</span>}
      </label>
      {children}
      {error && <div style={ERROR_STYLE}>{error}</div>}
    </div>
  );
}
